import {Component, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';

@Component({
    selector: 'checkbox',
    templateUrl: './input.checkbox.component.html'
})
export class CheckboxComponent {
    /**
     * Label of the checkbox
     */
    @Input() label: string;

    /**
     * Name of the checkbox
     */
    @Input() name: string;

    /**
     * value for the checkbox
     */
    @Input() value: string;

    /**
     * Value if the model is not checked
     * @type {boolean}
     */
    @Input() uncheckedValue: boolean  = false;

    /**
     * Required ore not
     */
    @Input() required: boolean;

    /**
     * the model
     */
    @Input() model: any;

    /**
     * Toggle for showing an input near the checkbox for manuel input
     */
    @Input() hasTextinput: boolean = false;

    /**
     * event if the model changes
     * @type {EventEmitter<any>}
     */
    @Output() modelChange: EventEmitter<any> = new EventEmitter();

    /**
     * access of the (optional) input element.
     */
    @ViewChild('inputValue') inputValue: ElementRef;

    /**
     * Function to update the model and inform the parent Component about it.
     * We can not use databinding here because it will not work together with
     * @param event
     */
    updateModel(event: any) {
        let newValue = event.target.checked === true? this.value : this.uncheckedValue;
        if(event.target.checked === false && this.inputValue?.nativeElement?.value) {
            this.inputValue.nativeElement.value = null;
        }
        this.model = newValue;
        this.modelChange.emit(newValue);
    }

    /**
     * called if the (optional) textiput is activated and used
     * @param value
     */
    changeTextInput(value: string): void {
        this.model = value;
        this.value = value;
        this.modelChange.emit(value);
    }
}
